import { render, staticRenderFns } from "./GGanttRow.vue?vue&type=template&id=5a2abe3d&scoped=true"
import script from "./GGanttRow.vue?vue&type=script&lang=js"
export * from "./GGanttRow.vue?vue&type=script&lang=js"
import style0 from "./GGanttRow.vue?vue&type=style&index=0&id=5a2abe3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2abe3d",
  null
  
)

export default component.exports